@let channelIdValue = channelId();
@if (channelIdValue) {
    <app-exports-monitoring-channel-drilldown></app-exports-monitoring-channel-drilldown>
} @else {
    <app-exports-monitoring-channel-overview></app-exports-monitoring-channel-overview>
}
